import { useEffect, useState, type FunctionComponent } from 'react';
import { CONTEXT, SubmissionModal } from '@fff-web/fff-ratings-and-reviews';
import env from '../../utils/env';
import ProductItem from './ProductItem/ProductItem';
import * as styles from './styles.module.scss';

const EMPTY_STATE = {
  productBrand: '',
  productName: '',
  imageUrl: '',
  productId: 0,
};

const setInitialRatings = (products) =>
  products.reduce((result, product) => {
    return {
      ...result,
      [product.productId]: 0,
    };
  }, {});

const getProduct = (products: Record<string, unknown>[], productId: number | null) =>
  products?.find((product) => product.productId === productId);

type ProductListProps = {
  products: {
    productId: number;
    imageUrl: string;
    productBrand: string;
    productName: string;
  }[];
};

const ProductList: FunctionComponent<ProductListProps> = ({ products }) => {
  const [ratings, setRatings] = useState({});
  const [selectedProductId, setSelectedProductId] = useState<number | null>(null);
  const [selectedValue, setSelectedValue] = useState(0);
  const selectedProduct = getProduct(products, selectedProductId) || EMPTY_STATE;

  const openModal = (productId: number, value: number) => {
    setSelectedProductId(productId);
    setSelectedValue(value);
  };
  const closeModal = () => setSelectedProductId(null);
  const handleOnSuccess = (response: {
    data: { items: { productId: string; rating: number }[] };
  }) => {
    const { productId, rating } = response.data.items[0];
    setRatings((prevState) => ({
      ...prevState,
      [productId]: rating,
    }));
  };
  useEffect(() => {
    if (products) {
      const initialRatings = setInitialRatings(products);
      setRatings(initialRatings);
    }
  }, [products]);

  return (
    <>
      <div className={styles.container} data-testid="rate-and-review-products">
        {products.map((product) => {
          const { imageUrl, productBrand, productId, productName } = product;
          const rating = ratings[productId as keyof typeof ratings] || 0;
          return (
            <ProductItem
              key={productId}
              productId={productId}
              imageUrl={imageUrl}
              productBrand={productBrand}
              productName={productName}
              rating={rating}
              onClick={openModal}
            />
          );
        })}
      </div>
      <SubmissionModal
        isOpen={!!selectedProductId}
        brandName={selectedProduct.productBrand}
        name={selectedProduct.productName}
        imgUrl={selectedProduct.imageUrl}
        productId={selectedProduct.productId}
        defaultRating={selectedValue}
        sku={selectedProduct.sku}
        context={CONTEXT.myReviews}
        env={env.appEnv}
        onSuccess={handleOnSuccess}
        closeModal={closeModal}
      />
    </>
  );
};

export default ProductList;
